export const ENV = {
  POST_API:import.meta.env.VITE_POST_API,
};